import ufeApi from 'services/api/ufeApi';

function getAbTestPersonalization(token, { deviceId, channel, placement, locale }) {
    const url = `/gway/v1/abtest-service/personalization?deviceId=${deviceId}&channel=${channel}&placement=${placement}&locale=${locale}`;

    const headers = {
        Authorization: `Bearer ${token}`
    };

    return ufeApi.makeRequest(url, { method: 'GET', headers }).then(data => data);
}

export default getAbTestPersonalization;
